module.exports = __webpack_public_path__ + "img/derRoteBlitz.7e2bbfc8.svg";